module.exports = __webpack_public_path__ + "media/bootstrap-icons/newspaper-bafd3da9.svg";